import get from 'lodash/get';
import reduce from 'lodash/reduce';
import { IIncompleteMemberFromBlacklist } from '../../../members/types';
import {
  IApiBlacklistIncluded,
  IApiBlacklistResult,
} from '../../models/blacklist/blacklist.types';
import {
  EIncludedType,
  IApiMemberBlacklistIncluded,
} from '../member/member.types';
import { IApiMainScore } from '../score/score.types';
import { IApiBlacklisRelationships, IApiBlacklist } from './blacklist.types';

const getRelationships = (
  relationships?: IApiBlacklisRelationships
): string[] =>
  reduce<IApiBlacklisRelationships, string[]>(
    relationships,
    (acc, value) => {
      return value.data && value.data.id ? acc.concat(value.data.id) : acc;
    },
    []
  );

export const blacklistSerializer = (
  apiBlacklist: IApiBlacklist,
  parent: IApiBlacklistResult
): IIncompleteMemberFromBlacklist => {
  const relationshipsID = getRelationships(apiBlacklist.relationships);
  const memberIncluded = relationshipsID.map((id: string) =>
    parent.included.find((current: IApiBlacklistIncluded) => current.id === id)
  );

  const scoreFiltered = memberIncluded.find(
    (current: IApiBlacklistIncluded) => current.type === EIncludedType.SCORE
  ) as IApiMainScore;

  const blacklistFiltered = memberIncluded.find(
    (current: IApiBlacklistIncluded) => current.type === EIncludedType.BLACKLIST
  ) as IApiMemberBlacklistIncluded;

  return {
    id: apiBlacklist.relationships.member.data.id,
    attributes: {
      score: scoreFiltered.attributes.score,
      personalityScore: scoreFiltered.attributes.personality_score,
      valueScore: scoreFiltered.attributes.value_score,
      visionScore: scoreFiltered.attributes.vision_score,
      mainPicture: get(apiBlacklist.relationships, 'picture.data.id'),
      isBlacklisted: get(blacklistFiltered, 'attributes.isBlacklisted'),
    },
  };
};
